import { useEffect, useState } from "react";
import { TypeMessage } from "../../../../../interfaces";
import { IAQuestion } from "./IAQuestion";
import { IAResponse } from "./IAResponse";

interface Props {
    text: string;
    type: TypeMessage;
}

export const IAMessage = ({ text, type }: Props) => {

  function cleanText(textToClean: string) {
    return textToClean.replace(/【.*?】/g, '');
  }

  if (type === TypeMessage.INPUT) {
    return (
      <IAQuestion text={text}/>
    )
  } else {
    return (
      <IAResponse text={cleanText(text)}/>
    )
  }
}